function getToggleButton(el) {
  return el.querySelector("[data-dropdown-toggle-button]")
}

function getDropdownMenu(el) {
  return el.querySelector("[data-dropdown-menu]")
}

function documentClickListener(cb) {
  return function click(event) {
    if (cb(event.target)) document.removeEventListener("click", click)
  }
}

function buttonFocusOut(cb) {
  return function focusOut(event) {
    this.removeEventListener("focusout", focusOut)
    if (!cb(event.relatedTarget))
      event.relatedTarget.addEventListener("focusout", buttonFocusOut(cb))
  }
}

function ToggleButtonListeners(container, button, menu) {
  function callback(target) {
    if (container.contains(target)) return false

    menu.classList.remove("is-dropdown-shown")
    menu.setAttribute("aria-hidden", "true")
    return true
  }

  function click(event) {
    event.preventDefault()
    menu.classList.add("is-dropdown-shown")
    menu.setAttribute("aria-hidden", "false")
    document.addEventListener("click", documentClickListener(callback))
  }

  function focus() {
    menu.classList.add("is-dropdown-shown")
    menu.setAttribute("aria-hidden", "false")
    button.addEventListener("focusout", buttonFocusOut(callback))
  }

  button.addEventListener("click", click)
  button.addEventListener("focus", focus)
}

class Dropdown {
  constructor(container) {
    this.container = container
    this.toggleButton = getToggleButton(container)
    this.dropdownMenu = getDropdownMenu(container)
  }

  enable() {
    ToggleButtonListeners(this.container, this.toggleButton, this.dropdownMenu)
    return this
  }
}

export default Dropdown
